module.exports = __webpack_public_path__ + "static/media/townhouse.41322267.svg";